<ng-template #content let-modal *ngIf="browserRefresh">
  <div class="slideshow-container">
    <div class="header">
      <h5>NOTIFICATIONS</h5>
      <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="content" *ngFor="let nt of notifications">
        <div class="active" *ngIf="nt.is_active==true">
          <div class="notification-title" *ngIf="nt.type=='NOTIFICATION_SELFHELP'">
            {{nt.title}}
          </div>
          <div class="notification-content" *ngIf="nt.type=='NOTIFICATION_SELFHELP'" [innerHTML]="nt.data">

          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>